// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"954408d5862fe8b3","2013":"874f33570d306d0f","3492":"8c9cb1f0df0204fe","3807":"e2d3ac40b77d87b8","7957":"67e48c4fd2e94e62","8466":"51fe8ff6cfc857e3"}[chunkId] + ".js";
};